import axiosInstance from './axiosInstance';

export async function getSublimationTemplateImageUrl({
  colours,
  gender,
  productSlug,
  side,
  size,
  templateId,
  overlay = true,
  webp = false,
}) {
  const queryParams = {
    colours: JSON.stringify(colours),
    gender,
    productSlug,
    side,
    size,
    templateId,
    overlay,
    webp,
  };

  try {
    const response = await axiosInstance.get('/sublimation', { params: queryParams });
    const imageUrl = response.data.imageUrl;
    return { imageUrl };
  } catch (error) {
    console.error('ERROR: ', error);
    // Return null if there is an error so the image is not displayed but the page still loads
    return { imageUrl: null };
  }
}
